import SnippetFolderIcon from '@mui/icons-material/SnippetFolder';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import { ReactElement, useState } from 'react';
import { ButtonProps, Labeled, useResourceContext, useTranslate } from 'react-admin';
import { useFormContext } from 'react-hook-form';
import FileManagerModal from './FileManagerModalInput/FileManagerModal';
import FileManagerModalInputItem from './FileManagerModalInput/FileManagerModalInputItem';

export { FileManagerModal };

interface FileManagerSelect {

}

export interface FileManagerModalInputProps extends Omit<ButtonProps, 'children'> {
  icon: ReactElement;
  source?: string;
  buttonOnly?: boolean;
  hideLabel?: boolean;
  mode?: 'image' | 'file';
  onSelect?: (fileManagerSelect: FileManagerSelect) => void;
}

const FileManagerModalInput = (props: FileManagerModalInputProps) => {
  const { label, icon, source, buttonOnly, hideLabel, sx, } = props;
  const translate = useTranslate();
  const [showDialog, setShowDialog] = useState(false);
  const resource = useResourceContext();
  const formContext = useFormContext();
  const { setValue, watch } = formContext ? formContext : {
    setValue: (_n: string, _v: any) => { },
    watch: (source: string) => null,
  };
  const value = source ? watch(source) : null;

  const onClick = () => {
    // console.log(1234);
    setShowDialog(true);
  }

  const handleSelectClick = (selection: Array<any>) => {
    if (source) {
      console.log('handleSelectClick', source, 0 === selection.length ? null : selection[0]);
      setValue(source, 0 === selection.length ? null : selection[0], { shouldDirty: true });
    }
    setShowDialog(false);
  }

  const handleCloseClick = () => {
    setShowDialog(false);
  }

  return (
    <Box sx={{ ...sx }}>
      {!buttonOnly
        ? !hideLabel
          ? <Labeled label={label ? label : translate(`resources.${resource}.fields.${source}`)} sx={{ width: '100%' }}>
            <FileManagerModalInputItem {...props} onClick={onClick} value={value} />
          </Labeled>
          : <FileManagerModalInputItem {...props} onClick={onClick} value={value} />
        : <IconButton onClick={onClick}>{icon}</IconButton>
      }
      <FileManagerModal label={label} source={source} showDialog={showDialog} handleSelectClick={handleSelectClick} handleCloseClick={handleCloseClick} />
    </Box >
  );
}

FileManagerModalInput.defaultProps = {
  title: '',
  icon: <SnippetFolderIcon />,
}

export default FileManagerModalInput;
